import TableComponentContainer from "../../../../Component/Tables/ReactstrapTable/TableComponent/TableComponent"

const TableComponent = () => {
  return (
    <div className='page-body'>
      <TableComponentContainer />
    </div>
  )
}

export default TableComponent